import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import _get from 'lodash/get';
import thunk from 'redux-thunk';

import InstrumentationDuck from 'ducks/instrumentation-duck';

import mocker from './middlewares/mocker';

import { AppDataReducer } from './reducers/app-data-reducer';
import OrderSearchDuck from './ducks/order-search-duck';
import UserDuck from './ducks/user-duck';
import MapDuck from './ducks/map-duck';
import DriverDuck from './ducks/driver-duck';
import TripDuck from './ducks/trip-duck';

export const rootReducer = combineReducers({
  appData: AppDataReducer,
  [OrderSearchDuck.store]: OrderSearchDuck.reducer,
  [UserDuck.store]: UserDuck.reducer,
  [MapDuck.store]: MapDuck.reducer,
  [DriverDuck.store]: DriverDuck.reducer,
  [TripDuck.store]: TripDuck.reducer,
  [InstrumentationDuck.store]: InstrumentationDuck.reducer,
});

const composeEnhancers =
  process.env.NODE_ENV !== 'production'
    ? _get(window, '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__', compose)
    : compose;

const devMiddleWare = process.env.NODE_ENV === 'development' ? [mocker] : [];

/**
 * Compose used here with applyMiddleware to setup chrome dev tools for redux
 * @see: https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
 */
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...devMiddleWare, thunk)),
);
export default store;
